import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import NP from "../../1. Core/NP";
import Select from "../../1. Core/Controls/Select/Select";
import {ServerAPI} from "../../1. Core/ServerAPI";
import {EventTournament, IBattle} from "../types";
import Label from "../../1. Core/Controls/Label/Label";
import {getNameAction} from "../../9. DataInput/HIGHLIGHT_STRUCTURE";


export default class HLStatDialog extends Dialog {

	private _Date: Date;

	private _Event: EventTournament;
	private _selectBattle: Select;
	private _tbl: HTMLTableElement;
	private _battles: IBattle[];


	_initFields(settings: object)
	{
		this._Event = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = 'Highlight stats';
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._AutoDestroy = true;
	}

	_render()
	{
		super._render();

		this._Date = new Date();


		this._selectBattle = new Select({
			ParentNode: this._contentNode,
			EvItemSelected: () => this.refresh(),
			Items: [{Content: 'All'}]
		})

		this._tbl = NP.createNode(this._contentNode, '', 'table')
		this._tbl.style.width = '100%'
		this._tbl.style.textAlign = 'center';

		ServerAPI.post("/battle/items", {
			EventId: this._Event.Id,
		}).then((response: { List: IBattle[], AllCount: number }) =>
		{

			if (!response.List?.length)
			{
				this.setContent(new Label({Content: 'There is no battles in is event'}));
				return;
			}

			this._battles = response.List;
			this._selectBattle.addItems(response.List.map(f => ({
				Content: f.Name,
				Value: f.Id
			})))

			this.refresh();
		})
	}

	async refresh()
	{

		let list = await ServerAPI.post<HLStatObj[]>("/mma/getHLStat", this._selectBattle.getValue() ?
			 [this._selectBattle.getValue()] : this._selectBattle.getItems().filter(v => !!v.Value).map(v => v.Value)
		)

		this._tbl.innerHTML = '';

		if (!this._selectBattle.getValue())
		{
			this.renderAll(list);
			return;
		}

		let battle = this._battles.find(b => b.Id == this._selectBattle.getValue())

		let row = this._tbl.insertRow()

		let cell1 = row.insertCell()
		cell1.style.width = '33%'
		cell1.innerText = battle.RedName

		let cell2 = row.insertCell()
		cell2.style.width = '33%'


		let cell3 = row.insertCell()
		cell3.style.width = '33%'
		cell3.innerText = battle.BlueName



		let rows = this.crateRows()

		list.forEach(item =>
		{
			let row = rows[item.Name]

			if (!row)
			{
				let rowName = getNameAction(item.Name)
				let parentRow = rows[rowName];
				parentRow.cells[1].style.textDecoration = 'underline';
				row = this._tbl.insertRow(this.getRowIndex(parentRow) + 1)
			}

			let redText = `${item.Red.Thrown} / ${item.Red.Landed}`
			let blueText = `${item.Blue.Thrown} / ${item.Blue.Landed}`

			let isBlueMode = null;

			if (item.Blue.Thrown && item.Red.Thrown && item.Red.Landed && item.Blue.Landed)
			{
				if (item.Blue.Landed / item.Blue.Thrown > item.Red.Landed / item.Red.Thrown)
					isBlueMode = true;
				else if (item.Blue.Landed / item.Blue.Thrown < item.Red.Landed / item.Red.Thrown)
					isBlueMode = false;
			}
			else if (item.Blue.Thrown && item.Red.Thrown)
			{
				if (item.Blue.Thrown > item.Red.Thrown)
					isBlueMode = true;
				else if (item.Blue.Thrown < item.Red.Thrown)
					isBlueMode = false;
			}
			else if (item.Blue.Thrown)
				isBlueMode = true;
			else if (item.Red.Thrown)
				isBlueMode = false


			row.insertCell().innerHTML = isBlueMode === false ? `<b>${redText}</b>` : redText;
			row.insertCell().innerText = item.Name;
			row.insertCell().innerHTML = isBlueMode ? `<b>${blueText}</b>` : blueText;

		})
	}

	crateRows()
	{
		return  {
			"Total punches": this._tbl.insertRow(),
			"Distance": this._tbl.insertRow(),
			"Clinch": this._tbl.insertRow(),
			"Parter": this._tbl.insertRow(),
			"Zone Head": this._tbl.insertRow(),
			"Zone Body": this._tbl.insertRow(),
			"Zone Legs": this._tbl.insertRow(),
			'Punch': this._tbl.insertRow(),
			'Elbow': this._tbl.insertRow(),
			'Knee': this._tbl.insertRow(),
			'Kick': this._tbl.insertRow(),
			'Takedown': this._tbl.insertRow(),
			'Transition': this._tbl.insertRow(),
			'Submission': this._tbl.insertRow()
		}
	}

	getRowIndex(r: HTMLTableRowElement)
	{
		for (let i = 0; i < this._tbl.rows.length; i++)
		{
			if (this._tbl.rows[i] == r)
				return i;
		}
		return -1;
	}

	renderAll(list: HLStatObj[])
	{
		this._tbl.innerHTML = '';
		let row = this._tbl.insertRow()
		row.insertCell().width = '50%'
		row.insertCell().width = '50%'

		let rows = this.crateRows()

		list.forEach(item =>
		{

			let row = rows[item.Name]

			if (!row)
			{
				let rowName = getNameAction(item.Name)
				let parentRow = rows[rowName];
				parentRow.cells[0].style.textDecoration = 'underline';
				row = this._tbl.insertRow(this.getRowIndex(parentRow) + 1)
			}


			let text = `${(item.Blue.Thrown + item.Red.Thrown)} / ${(item.Blue.Landed + item.Red.Landed)}`
			row.insertCell().innerText = item.Name
			row.insertCell().innerText = text
		})
	}


	async _onOkButtonClick()
	{
		this.EvOkButtonClick.fire(this);
		this.hide();
	}
}

interface HLStatObj {
	Name: string,
	Red: {
		Thrown;
		Landed;
		Damaging;
	}

	Blue: {
		Thrown;
		Landed;
		Damaging;
	}
}